import { authApi } from "shared/api/authApi";

export const verifyResetCodeRequest = (payload) => {
  return authApi.verifyResetCode(payload);
};
